import { useLocation, useNavigate } from 'react-router-dom';

type UseUrlSyncedModalReturn = {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
};

const useUrlSyncedModal = (
  paramKey: string,
  paramValue: string,
): UseUrlSyncedModalReturn => {
  const location = useLocation();
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(location.search);
  const open = urlParams.get(paramKey) === paramValue;

  const onOpen = () => {
    const newParams = new URLSearchParams(location.search);
    newParams.set(paramKey, paramValue);
    navigate(`${location.pathname}?${newParams.toString()}`);
  };

  const onClose = () => {
    const newParams = new URLSearchParams(location.search);
    newParams.delete(paramKey);
    const newSearch = newParams.toString();
    navigate(`${location.pathname}${newSearch ? `?${newSearch}` : ''}`, {
      replace: true,
    });
  };

  return { open, onOpen, onClose };
};

export default useUrlSyncedModal;
